export { default } from './EditorialCard';
